import { Component, EventEmitter, Input, Output, Provider } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { PaymentMethod, PaymentType, ProviderType } from '../../models/provider.model';

@Component({
  selector: 'app-create-provider-modal',
  templateUrl: './create-provider-modal.component.html',
  styleUrl: './create-provider-modal.component.scss'
})
export class CreateProviderModalComponent {
  @Input() showProviderModal: boolean = false;
  @Input() providerTypes: ProviderType[] = [];
  @Input() paymentTypes: PaymentType[] = [];
  @Input() paymentMethods: PaymentMethod[] = [];

  @Output() createProvider: EventEmitter<Provider> = new EventEmitter<Provider>();
  @Output() closeModal: EventEmitter<void> = new EventEmitter<void>();

  public providerForm: any;
  taxRegimes = [
    { id: 1, name: 'Persona Física' },
    { id: 2, name: 'Persona Moral' },
    { id: 3, name: 'Extranjero' },
    { id: 4, name: 'No Contribuyente' },
  ];

  constructor(private fb: FormBuilder) {
    this.providerForm = this.fb.group({
      id: [''],
      providerTaxRegimeId: [0, Validators.required],
      providerKey: ['', [Validators.required, Validators.minLength(2)]],
      providerShortName: ['', [Validators.required, Validators.minLength(2)]],
      providerPhoneCode: ['+52', [Validators.required]],
      providerTelephone: ['', [Validators.required, Validators.minLength(10)]],
      providerEmail: ['', [Validators.required, Validators.pattern('^\\S+@\\S+\\.\\S+$')]],
      providerTypeId: [null, [Validators.required, Validators.min(1)]],
      isInvoiceRequired: [false, [Validators.required]],
    });
  }

  handleCancelModal() {
    this.closeModal.emit();
    this.providerForm.reset();
  }

  onCreateProvider() {
    const newProvider = this.providerForm.value;
    this.createProvider.emit(newProvider);
  }
}
